export default "__VITE_ASSET__DRamkbuo__"